import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminDashboard from '../components/admin/AdminDashboard';
import AdminTours from '../components/admin/AdminTours';
import AdminBookings from '../components/admin/AdminBookings';
import AdminUsers from '../components/admin/AdminUsers';

import AdminBlog from '../components/admin/AdminBlog';
import ManageMessage from '../components/admin/ManageMessage/ManageMessage';
import useAuthStore from '../store/authStore';
import { Menu, X } from 'lucide-react';
import AdminHotelRequests from '../components/admin/AdminHotelRequests';
import { AdminFlightRequests } from '../components/admin/AdminFlightRequests';

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { user } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role !== 'admin') {
      navigate('/');
    }
  }, [user, navigate]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-slate-950">
      {/* Mobile menu button */}
      <button 
        onClick={toggleSidebar}
        className="md:hidden fixed top-20 right-4 z-40 p-2 rounded-lg bg-white dark:bg-slate-900 shadow-lg"
      >
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <AdminSidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={setSidebarOpen} 
      />

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-4 md:p-8">
          {activeTab === 'dashboard' && <AdminDashboard />}
          {activeTab === 'tours' && <AdminTours />}
          {activeTab === 'bookings' && <AdminBookings />}
          {activeTab === 'users' && <AdminUsers />}
            {activeTab === 'blogs' && <AdminBlog />}
              {activeTab === 'messages' && <ManageMessage />}
              {activeTab === 'hotels' && <AdminHotelRequests />}
                {activeTab === 'flights' && <AdminFlightRequests />}
        </div>
      </main>
    </div>
  );
}
